import { computed } from "vue";
import { useFormStore } from "@/features/blueprint/stores/useFormStore";
import { getQuestionSchema } from "@/features/blueprint/schema/questionSchema";
import { buildNavSections, calculateCompletedSectionIndices, checkIsSummaryStep, getActiveSection } from "@/features/blueprint/viewmodels/BlueprintNavigationViewModel";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";

export function useBlueprintState(t: (key: string) => string) {
    const formStore = useFormStore();

    const questionSchema = computed<QuestionSchema[]>(() => getQuestionSchema(t));
    const navSections = computed<QuestionSchema[]>(() =>
        buildNavSections(t, questionSchema.value)
    );

    const currentStep = computed(() => formStore.currentSectionIndex + 1);
    const totalSteps = computed(() => navSections.value.length);

    const completedSectionIndices = computed(() =>
        calculateCompletedSectionIndices(questionSchema.value, formStore.answers)
    );

    const isSummaryStep = computed(() =>
        checkIsSummaryStep(formStore.currentSectionIndex, questionSchema.value)
    );

    const activeSection = computed(() =>
        getActiveSection(questionSchema.value, formStore.currentSectionIndex)
    );

    return {
        questionSchema,
        navSections,
        currentStep,
        totalSteps,
        completedSectionIndices,
        isSummaryStep,
        activeSection,
    };
}
